/* Mighty Dink v8: card countdowns, PDP thumbnail arrows, pre-order button label, kicker labels, popup gating */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var parse = function (s) { return Date.parse(String(s || '').replace(/([+-]\d\d)(\d\d)$/, '$1:$2')); };

  /* email popup: reveal only after 50% scroll (v11: no timer) */
  var root = document.documentElement;
  function okPopup() { root.classList.add('md-popup-ok'); document.removeEventListener('scroll', onScroll, true); }
  function onScroll(e) {
    var el = e && e.target && e.target.nodeType === 1 ? e.target : document.scrollingElement;
    var h = el.scrollHeight - el.clientHeight;
    if (h > 200 && el.scrollTop / h >= 0.5) okPopup();
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  /* card countdowns */
  function tickCards() {
    document.querySelectorAll('[data-md-cd]').forEach(function (el) {
      var t = parse(el.getAttribute('data-md-cd'));
      if (isNaN(t)) { el.hidden = true; return; }
      var r = Math.floor((t - Date.now()) / 1000);
      if (r <= 0) { el.hidden = true; return; }
      var txt = el.querySelector('[data-md-cd-text]');
      if (txt) txt.textContent = Math.floor(r / 86400) + 'd : ' + pad(Math.floor(r % 86400 / 3600)) + 'h : ' + pad(Math.floor(r % 3600 / 60)) + 'm : ' + pad(r % 60) + 's';
      el.hidden = false;
    });
  }

  /* section kicker labels */
  var KICK = { 'best sellers': 'Most loved', 'paddles': 'Shop the range', 'shop paddles': 'Shop the range', 'you may also like': 'Pair it with' };
  function kickers() {
    document.querySelectorAll('.section-resource-list h2, .section-resource-list h3, .section-resource-list p, product-recommendations h2, product-recommendations h3').forEach(function (h) {
      if (h.dataset.mdKick) return;
      var k = KICK[(h.textContent || '').trim().toLowerCase()];
      if (!k) return;
      h.dataset.mdKick = '1';
      var s = document.createElement('span'); s.className = 'md-kicker'; s.textContent = k;
      h.parentNode.insertBefore(s, h);
    });
  }

  /* PDP: up/down arrows for the vertical thumbnail column */
  function thumbArrows() {
    document.querySelectorAll('media-gallery slideshow-controls[thumbnails] .slideshow-controls__thumbnails').forEach(function (list) {
      if (list.classList.contains('md-thumbs-done') || !list.querySelector('button')) return;
      list.classList.add('md-thumbs-done');
      var host = list.closest('slideshow-controls') || list.parentElement;
      if (host.querySelector('.md-thumb-nav')) return;
      var nav = document.createElement('div'); nav.className = 'md-thumb-nav';
      nav.innerHTML = '<button type="button" aria-label="Previous image" data-dir="-1"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg></button>' +
        '<button type="button" aria-label="Next image" data-dir="1"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12l7 7 7-7"/></svg></button>';
      host.appendChild(nav);
      function btns() { return Array.prototype.slice.call(list.querySelectorAll('button')); }
      function cur() { var b = btns(); for (var i = 0; i < b.length; i++) if (b[i].getAttribute('aria-selected') === 'true' || b[i].getAttribute('aria-current') === 'true') return i; return 0; }
      function upd() { var b = btns(), c = cur(); nav.children[0].disabled = c <= 0; nav.children[1].disabled = c >= b.length - 1; }
      nav.addEventListener('click', function (e) {
        var bt = e.target.closest('button[data-dir]'); if (!bt) return;
        var b = btns(), n = Math.max(0, Math.min(b.length - 1, cur() + +bt.dataset.dir));
        b[n].click(); b[n].scrollIntoView({ block: 'nearest', inline: 'nearest' }); setTimeout(upd, 80);
      });
      list.addEventListener('click', function () { setTimeout(upd, 80); });
      upd();
      if (btns().length < 2) nav.hidden = true;
    });
  }

  /* PDP: keep pre-order price label in sync with the selected variant */
  function poButton() {
    var po = document.querySelector('[data-md-po]');
    if (!po) return;
    var prices = {}; try { prices = JSON.parse(po.getAttribute('data-prices') || '{}'); } catch (e) {}
    var scope = po.closest('.product-information') || document;
    var idEl = scope.querySelector('form input[name="id"]');
    var p = idEl && prices[idEl.value];
    var pr = po.querySelector('.md-po__price strong');
    if (p && pr && pr.textContent !== p) pr.textContent = p;
  }

  function all() { kickers(); thumbArrows(); poButton(); }
  tickCards(); setInterval(tickCards, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  document.addEventListener('change', function () { setTimeout(poButton, 250); setTimeout(poButton, 900); });
  new MutationObserver(function () { clearTimeout(window.__mdv8t); window.__mdv8t = setTimeout(all, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* r3: hide store-name vendor on cards */
(function(){function f(){document.querySelectorAll('product-card [class*="vendor_md"] p').forEach(function(p){if(/mighty dink/i.test(p.textContent))p.parentElement.style.display='none'})}f();document.addEventListener('DOMContentLoaded',f);new MutationObserver(f).observe(document.documentElement,{childList:true,subtree:true});})();
